<!-- Solutions Section Start -->
<section class="cyclops tech-section" id="solutions">
  <div class="container">
    <h2 class="section-title gradient-text text-center" style="color:#b70000 ; padding-bottom: 10px;">Our Solutions</h2>
    <div class="row">

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="solution-card">
          <div class="solution-media text-center">
            <div class="d-flex justify-content-center gap-2 mb-2">
              <!-- <img src="assets/images/solutions/IMG_1044.jpeg" width="100" height="100" alt="Solution Image 1" class="img-fluid rounded" style="padding-right: 10px;"> -->
              <!-- <img src="assets/images/solutions/IMG_1044.jpeg" width="100" height="100" alt="Solution Image 2" class="img-fluid rounded" style="padding-right: 10px;"> -->
              <!-- <img src="assets/images/solutions/IMG_1044.jpeg" width="100" height="100" alt="Solution Image 3" class="img-fluid rounded" style="padding-right: 10px;"> -->
            </div>
            <div>
              <img src="assets/images/solutions/IMG_5598.jpeg" width="auto" height="100" alt="Solution Image 3"
                class="img-fluid rounded" style="padding-right: 10px;">

            </div>
          </div>

          <h5 class="solution-title">Manufacturing & Systems Integration</h5>
          <p class="solution-desc" style="padding-bottom: 10px;">
            CYCLOPS ensures precision and reliability by developing technologies in-house and integrating them into
            complete, mission-ready systems. Our end-to-end approach guarantees field-proven solutions delivered on time
            and to specification</p>
          <a routerLink="/solution" fragment="manufacturing" class="btn btn-primary">Explore Manufacturing</a>
        </div>
      </div>


      <div class="col-lg-4 col-md-6 mb-4">
        <div class="solution-card">
          <div class="solution-media">
            <img src="assets/images/phoneix.png" alt="Solution One" class="img-fluid rounded">
          </div>
          <h5 class="solution-title">UAV Solutions</h5>
          <p class="solution-desc" style="padding-bottom: 10px;">
            CYCLOPS designs and integrates lightweight, tactical Unmanned Aerial Systems (UAS) for strike and ISR
            missions. Our platforms are optimized for portability, modular payloads, and cost-effective
            production—supporting operations from short to long range with precision and reliability.
          </p>
          <a routerLink="/solution" fragment="uavs" class="btn btn-primary">Explore UAV solutions </a>
        </div>
      </div>

      <!-- Card 2 (Video Example) -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="solution-card">
          <div class="solution-media">
            <img src="assets/images/bordersecurity.png" alt="Solution One" class="img-fluid rounded">
          </div>
          <h5 class="solution-title">Border Security Solutions</h5>
          <p class="solution-desc" style="padding-bottom: 10px;">
            CYCLOPS delivers integrated border security capabilities, combining secure tactical communications,
            multi-layer surveillance, radars, detection systems, and perimeter control. We also provide on-site
            technical assistance, MRO services, and specialized training—tailoring solutions to protect critical
            infrastructure and support complex missions.
          </p>
          <a routerLink="/solution" fragment="border-security" class="btn btn-primary">Explore Border Security</a>
        </div>
      </div>


      <div class="col-lg-4 col-md-6 mb-4">
        <div class="solution-card">
          <div class="solution-media">
            <img src="assets/images/isrhp.png" alt="Solution One" class="img-fluid rounded">
          </div>
          <h5 class="solution-title">Tactical & ISR Solutions</h5>
          <p class="solution-desc" style="padding-bottom: 10px;">
            CYCLOPS delivers field-ready tactical systems and advanced ISR capabilities that enhance situational
            awareness and mission effectiveness.
            From portable strike platforms to multi-sensor reconnaissance technologies, our solutions provide real-time
            intelligence for complex missions.
          </p>
          <a routerLink="/solution" fragment="tactical" class="btn btn-primary">Explore Tactical & ISR Solutions</a>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="solution-card">
          <div class="solution-media">
            <img src="assets/images/ps2.jpg" alt="Solution One" class="img-fluid rounded">
          </div>
          <h5 class="solution-title">Secure Transportation & Protective Services </h5>
          <p class="solution-desc" style="padding-bottom: 10px;">
            Discreet transportation, journey coordination, and protective support for institutional and diplomatic
            missions operating in complex environments
          </p>
          <a routerLink="/solution" fragment="protective-services " class="btn btn-primary">Explore Protective
            Services</a>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="solution-card">
          <div class="solution-media">
            <img src="assets/images/MRO/MRO1.jpeg" alt="Solution One" class="img-fluid rounded">
          </div>
          <h5 class="solution-title">Maintenance, Repair & Overhaul </h5>
          <p class="solution-desc" style="padding-bottom: 10px;">
            CYCLOPS provides MRO services for military and civilian vehicles, including armored platforms with
            protection levels up to B6/B7. With facilities in the United States and the Middle East, we provide
            diagnostics, repair,
            and overhaul solutions that keep fleets mission-ready and compliant.
          </p>
          <a routerLink="/solution" fragment="mro" class="btn btn-primary">Explore MRO</a>
        </div>
      </div>


      <div class="col-lg-4 col-md-6 mb-4">
        <div class="solution-card">
          <div class="solution-media">
            <img src="assets/images/sdos.png" alt="Solution One" class="img-fluid rounded">
          </div>
          <h5 class="solution-title">Strategic Advisory & Operational Support </h5>
          <p class="solution-desc" style="padding-bottom: 10px;">
            CYCLOPS supports government and defense partners with program development, international market engagement,
            and operational coordination across domestic and global markets. We assist clients in structuring
            initiatives, aligning stakeholder engagement, and supporting effective implementation within regulatory and
            operational frameworks.
          </p>
          <a routerLink="/solution" fragment="sdo" class="btn btn-primary">Explore Strategic Advisory</a>
        </div>
      </div>




      <div class="col-lg-4 col-md-6 mb-4">
        <div class="solution-card">
          <div class="solution-media">
            <img src="assets/images/lise.png" alt="Solution Three" class="img-fluid rounded">
          </div>
          <h5 class="solution-title">Licensing, Compliance & Export Consulting</h5>
          <p class="solution-desc" style="padding-bottom: 10px;">
            CYCLOPS provides expert guidance on U.S. ITAR compliance, export licensing, and international defense trade.
            From DSP-5 and DSP-73 applications to Technical Assistance Agreements, we help clients navigate regulations
            and keep programs mission-ready.
          </p>
          <a routerLink="/solution" fragment="licensing" class="btn btn-primary"> Explore Licensing & Compliance</a>
        </div>
      </div>






    </div>
  </div>
</section>
<!-- Solutions Section End -->